import moment from "moment";
import "moment/locale/es";
import { dineroDisabledMask, cuentaMask } from "../Components/Items";
import { HeaderEmpresaCard } from "../Components/PdfComponents/HeaderEmpresaCard";

moment.locale("es");

const ordenAgregarInventarioPdf = (data) => {
  const { orden, empresa } = data;
  
  const mostrarRegimen = !empresa?.deshabilitarRegimenFiscal;
  
  const layoutTabla = {
    hLineWidth: function (i, node) { return 1; },
    vLineWidth: function (i, node) { return 1; },
    hLineColor: function (i, node) { return "#e8e8e8"; },
    vLineColor: function (i, node) { return "#e8e8e8"; },
    fillColor: function (rowIndex, node, columnIndex) {
        return (rowIndex % 2 === 0) ? '#f9f9f9' : null;
    }
  };

  const estiloHeaderTabla = {
      bold: true,
      fontSize: 10,
      color: 'black',
      fillColor: '#dedede', 
      margin: [5, 5, 5, 5]
  };

  const estiloCelda = {
      fontSize: 10,
      margin: [5, 5, 5, 5]
  };

  const mostrarLotes = orden.conLotesYCaducidades;
  const tableWidths = mostrarLotes ? ['12%', '28%', '15%', '15%', '15%', '15%'] : ['15%', '45%', '20%', '20%'];

  const tableHeaders = [
      { text: 'Clave', style: estiloHeaderTabla },
      { text: 'Insumo', style: estiloHeaderTabla },
      { text: 'Costo', style: estiloHeaderTabla, alignment: 'right' },
      { text: 'Cantidad', style: estiloHeaderTabla, alignment: 'right' },
  ];

  if (mostrarLotes) {
      tableHeaders.push({ text: 'Lote', style: estiloHeaderTabla, alignment: 'center' });
      tableHeaders.push({ text: 'Caducidad', style: estiloHeaderTabla, alignment: 'center' });
  }

  const tableBody = [tableHeaders];

  if (orden.insumos && orden.insumos.length > 0) {
      orden.insumos.forEach(item => {
          const insumo = item.insumoId || {};

          const row = [
              { text: insumo.clave || '-', style: estiloCelda },
              { text: insumo.descripcion || 'Insumo sin nombre', style: estiloCelda },
              { text: dineroDisabledMask(item.costo || 0), style: estiloCelda, alignment: 'right' },
              { text: item.cantidad || 0, style: estiloCelda, alignment: 'right' },
          ];

          if (mostrarLotes) {
              row.push({ text: item.lote || '-', style: estiloCelda, alignment: 'center' });
              row.push({ text: item.caducidad ? moment(item.caducidad).format('DD/MM/YYYY') : '-', style: estiloCelda, alignment: 'center' });
          }

          tableBody.push(row);
      });
  } else {
      tableBody.push([
          { text: 'No hay insumos agregados', style: estiloCelda, colSpan: mostrarLotes ? 6 : 4, alignment: 'center' },
          ...Array(mostrarLotes ? 5 : 3).fill({})
      ]);
  }

  let cuentaContableTexto = 'N/A';
  if (orden.contabilizar && orden.cuentaAbonoId) {
      const c = orden.cuentaAbonoId;
      const numeroCuenta = `${c.nivel1 || ''}${c.nivel2 || ''}${c.nivel3 || ''}${c.nivel4 || ''}${c.nivel5 || ''}`;
      cuentaContableTexto = `${cuentaMask(numeroCuenta)} - ${c.descripcion || ''}`;
  }

  var dd = {
    content: [
      
      {
        style: 'tableExample',
        table: {
          widths: ['20%', '50%', '30%'],
          layout: 'noBorders',
          body: [
            [
              ...HeaderEmpresaCard(empresa, mostrarRegimen, false, 
                {
                    border: [false, false, false, false],
                    table: {
                      headerRows: 1,
                      widths: ['100%'],
                      body : [
                        [
                            {
                                text: 'N° Orden:',
                                style: 'subheader',
                                alignment: 'center'
                            }
                        ],
                         [
                          {
                            text: orden?.numero || '-',
                            style: 'textoChico',
                            alignment: 'center'
                          }
                        ],
                        [
                          {
                            text: 'Generado:',
                            style: 'subheader',
                            alignment: 'center'
                          }
                        ],
                        [
                          {
                            text: moment().format('DD/MM/YYYY'),
                            style: 'subheader',
                            alignment: 'center'
                          }
                        ],
                      ]
                    },
                    layout: 'noBorders'
                }
              )
            ]
          ]
        }
      },
      
      { 
        text: `Orden de Agregar Inventario N° ${orden?.numero || '-'}`, 
        style: 'tituloPrincipal', 
        alignment: 'left',
        margin: [0, 5, 0, 10] 
      }, 
      {
        style: 'tableExample',
        margin: [0, 0, 0, 15], 
        table: {
          widths: ['25%', '25%', '25%', '25%'],
          body: [
            [
                { text: 'Proyecto', style: estiloHeaderTabla },
                { text: orden.proyectoId?.nombre || 'N/A', style: estiloCelda },
                { text: 'Referencia', style: estiloHeaderTabla },
                { text: orden.referencia || 'N/A', style: estiloCelda }
            ],
            [
                { text: 'Contabilizar', style: estiloHeaderTabla },
                { text: orden.contabilizar ? 'Sí' : 'No', style: estiloCelda },
                { text: 'Cuenta Abono', style: estiloHeaderTabla },
                { text: cuentaContableTexto, style: estiloCelda }
            ]
          ]
        },
        layout: {
            hLineWidth: (i) => 1,
            vLineWidth: (i) => 1,
            hLineColor: '#bdbdbd',
            vLineColor: '#bdbdbd'
        }
      },

      { text: 'Detalle de Insumos', style: 'tableHeaderIzquierda', margin: [0, 0, 0, 5] },
      {
        table: {
          widths: tableWidths,
          body: tableBody
        },
        layout: layoutTabla,
        margin: [0, 0, 0, 15] 
      },

      {
          margin: [0, 60, 0, 0], 
          stack: [
              {
                  canvas: [{ type: 'line', x1: 0, y1: 0, x2: 200, y2: 0, lineWidth: 1 }]
              },
              {
                  text: 'Firma de Autorización',
                  style: 'textoChico',
                  alignment: 'center', 
                  margin: [0, 5, 0, 0] 
              }
          ],
          alignment: 'center' 
      }
    ],

    images: {
      logo: empresa.logo?.base64Completa ? empresa.logo.base64Completa : '',
    },
    styles: {
      tituloPrincipal: { fontSize: 16, bold: true, color: 'black' }, 
      header: { fontSize: 9, bold: true },
      subheader: { fontSize: 8, bold: true },
      tableExample: { margin: [0, 0, 0, 0] }, 
      tablaSinMargen: { margin: [0, 0, 0, 0] },
      tableHeaderIzquierda: { bold: true, fontSize: 14, color: 'black' },
      tableHeader: {
        bold: true,
        fontSize: 12,
        color: 'black',
        alignment: 'center'
      },
      textoChico: { fontSize: 8 },
      textoChicoData: { fontSize: 6 },
    },
    pageSize: 'LETTER',
    pageMargins: [40, 40, 40, 40]
  };
  if (orden.estado === 0) {
    dd.watermark = { 
      text: 'CANCELADA', 
      color: 'gray', 
      opacity: 0.2, 
      bold: true, 
      italics: false,
      angle: 45 
    };
  }
  return dd;
};

export default ordenAgregarInventarioPdf;